import { CloseOutlined, LeftOutlined } from '@easyv/react-icons';
import { useImmer } from 'use-immer';
import { isNil } from '@/utils';
import { useGetNewModelMaterial, getOriginModelMaterial } from './model';
import { Checkbox, Select } from '@arco-design/web-react';
import * as React from 'react';
import { ProModal } from '../ProModal';

interface ReplaceMaterialModalProps {
  /**  model component */
  comp: any;
  url: string | undefined;
  open: boolean;
  mode: 'model' | 'instanceModel';
  onClose: () => void;
  onStart: () => void;
  onFinish: (success: boolean) => void;
}

export function ReplaceMaterialModal(props: ReplaceMaterialModalProps) {
  const { comp, url, open, mode, onClose, onStart, onFinish } = props;
  const [isNeedSaveUnmappedMaterial, setIsNeedSaveUnmappedMaterial] = React.useState(false);

  const [replacedMaterialTable, setReplacedMaterialTable] = useImmer<
    ({ name: string; id: string } | undefined)[]
  >([]);

  // TODO 根据id获取组件
  const originalMats = getOriginModelMaterial(comp);
  const originalMatOptions = originalMats.map((a) => ({ label: a.name, value: a.id }));
  const filterOption = (
    input: string,
    option?: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
  ) => {
    return (option?.props.children ?? '').toLowerCase().includes(input.toLowerCase());
  };

  // TODO 根据url获取新材质
  const { data: newMats, loaded } = useGetNewModelMaterial(comp.engine, url);
  React.useEffect(() => {
    if (!loaded) return;
    console.log('执行useefect', newMats);
    const replaceTable: ({ name: string; id: string } | undefined)[] = [];
    for (let i = 0; i < newMats.length; i++) {
      const newMat = newMats[i];

      const sameOldMat = originalMats.find((a) => a.name === newMat.name);
      if (sameOldMat) {
        replaceTable[i] = { name: sameOldMat.name, id: sameOldMat.id };
      }
    }
    console.log('new tqable', replaceTable);

    setReplacedMaterialTable(replaceTable);
    // 默认选中同名的新旧材质
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded]);

  return (
    <ProModal
      alignCenter
      unmountOnExit
      visible={open}
      title={
        <div className='flex items-center text-base align-middle h-10 text-white justify-between'>
          <div>材质映射</div>
          <CloseOutlined
            className='anticon text-content3 text-lg flex justify-center cursor-pointer hover:text-white'
            onClick={() => {
              onClose();
              onFinish(false);
            }}
          />
        </div>
      }
      closable={false}
      cancelText='取消'
      okText='导入'
      textInFooter={
        mode === 'model' ? (
          <Checkbox
            checked={isNeedSaveUnmappedMaterial}
            onChange={(e) => {
              setIsNeedSaveUnmappedMaterial(e);
            }}
          >
            未被映射的原模型材质保存至材质预设
          </Checkbox>
        ) : null
      }
      onOk={async () => {
        onClose();
        const table: {
          slot: {
            name: string;
            id: string;
          }[];
          oldSlot?:
            | {
                name: string;
                id: string;
              }
            | undefined;
        }[] = [];
        for (let i = 0; i < newMats.length; i++) {
          table.push({
            slot: [newMats[i]],
            oldSlot: replacedMaterialTable[i],
          });
        }

        console.log('replaced with table', table, url, originalMats, newMats);
        onStart();
        // TODO 替换模型材质replaceModelAssetWithMat(mode, entityId, url, table, isNeedSaveUnmappedMaterial);
        if (comp) await comp.replaceModelByMaterialMapping(url, table);
        setReplacedMaterialTable([]);
        onFinish(true);
      }}
      onCancel={() => {
        setReplacedMaterialTable([]);
        onFinish(false);
        onClose();
      }}
    >
      <div className='mt-2 mb-2 flex gap-x-3 h-5 leading-5 text-textColorSecondary'>
        <div className='w-1/2'>新模型材质</div>
        <div className='w-1/2'>映射对象</div>
      </div>
      <div className='h-60 overflow-auto no-scroll-container w-full flex gap-x-3'>
        <div className='w-1/2 flex flex-col gap-y-1'>
          {newMats.map((m) => {
            return (
              <div key={m.id} className='w-full h-7 y-1 rounded flex items-center justify-between'>
                <div className='flex items-center gap-x-1 h-7'>
                  {/* <WaterDropOutlined /> */}
                  <div className='flex-auto flex items-center leading-5 text-white'>
                    <span>{m.name}</span>
                  </div>
                </div>
                <LeftOutlined className='pr-2' />
              </div>
            );
          })}
        </div>
        <div className='w-1/2 flex flex-col gap-y-1'>
          {newMats.map((m, index) => {
            return (
              <Select
                key={m.id}
                size='small'
                showSearch
                allowClear
                className='w-full'
                placeholder='选择映射材质'
                filterOption={filterOption}
                options={originalMatOptions}
                value={replacedMaterialTable[index]?.id}
                onChange={(id: string) => {
                  setReplacedMaterialTable((draft) => {
                    const name = originalMats.find((a) => a.id === id)?.name;
                    if (isNil(name)) {
                      draft[index] = undefined;
                    } else draft[index] = { id, name };
                  });
                }}
              >
                {originalMatOptions.map((option) => {
                  return (
                    <Select.Option
                      className='h-8 flex items-center'
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </Select.Option>
                  );
                })}
              </Select>
            );
          })}
        </div>
      </div>
    </ProModal>
  );
}
